import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice pH - Calcul du pH de l'acidité";
const DESCRIPTION =
  "Calculatrice pH - Calcul du pH de l'acidité. Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "ph calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/ph-calculator/";
function PhCalculator() {
  const [hConcentration, setHConcentration] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!hConcentration) {
        setError("Veuillez entrer la concentration d'ions hydrogène");
        setResult(null);
        return;
      }
      const h = parseFloat(hConcentration);
      if (h <= 0) {
        setError("La concentration doit être positive");
        setResult(null);
        return;
      }
      const ph = -Math.log10(h);
      let classification = "";
      if (ph < 7) classification = "Acide";
      else if (ph === 7) classification = "Neutre";
      else classification = "Basique";
      setResult({
        pH: ph.toFixed(2),
        classification: classification
      });
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice pH calcule le potentiel hydrogène à partir de la concentration
                  d'ions hydrogène. Formule: pH = -log₁₀[H⁺]. Les valeurs pH varient de 0 à 14,
                  7 étant neutre, moins de 7 acide, et plus de 7 basique.
                </p>
                <ul>
                  <li>Calcul instantané du pH</li>
                  <li>Classification automatique (acide/neutre/basique)</li>
                  <li>Utile pour la chimie</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Concentration d'ions H+ (mol/L)
                      </label>
                      <input
                        type="number"
                        value={hConcentration}
                        onChange={(e) => setHConcentration(e.target.value)}
                        placeholder="Entrez [H+]"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>pH: <strong>{result.pH}</strong></p>
                      <p>Classification: <strong>{result.classification}</strong></p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default PhCalculator;
